import {createStore} from 'vuex';
import auth from './modules/auth';
import assemble from './modules/assemble';
import customer_colours from './modules/customer_colours';

const store = createStore({
    modules : {
        auth,
        assemble,
        customer_colours
    }
})
export default store;